<template>
  <form @submit.prevent="handleSubmit">
    <b-row v-if="!selectedData">
      <b-col md="6" class="mb-3">
        <label class="mb-1">
          Fleet
          <span class="text-danger">*</span>
        </label>
        <v-select
          :options="fleetOptions"
          v-model="dataForm.vehicleId"
          label="name"
          :reduce="(option) => option?.id"
          @input="fetchVehiclePowerList"
        ></v-select>
      </b-col>
      <b-col md="6">
        <label class="mb-1">
          Effective Date
          <span class="text-danger">*</span>
        </label>
        <date-picker
          type="date"
          placeholder="Select time"
          format="DD-MM-YYYY"
          value-type="DD-MM-YYYY"
          v-model="dataForm.effectiveDate"
          class="w-100"
        ></date-picker>
      </b-col>
      <b-col md="12" class="mb-3">
        <label class="mb-1">Description</label>
        <b-textarea v-model="dataForm.description" />
      </b-col>
    </b-row>
    <b-row v-else class="mb-3">
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Fleet Name
      </b-col>
      <b-col md="8" style="color: black">
        <b-badge variant="success">
          {{ selectedData?.vehicle_name ?? '-' }}
        </b-badge>
      </b-col>
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Effective Date
      </b-col>
      <b-col md="8" style="color: black">
        {{
          dataForm?.effectiveDate ? formateDate(dataForm?.effectiveDate) : '-'
        }}
      </b-col>
      <!-- <b-col md="4" style="color: black" class="mb-3 font-semibold">
          Creator
        </b-col>
        <b-col md="8" style="color: black" class="mb-2">
          {{ selectedData?.user?.requestor?.name ?? '-' }}
        </b-col> -->
      <b-col md="4" style="color: black" class="mb-3 font-semibold">
        Description
      </b-col>
      <b-col md="8" style="color: black">
        {{ dataForm?.description ?? '-' }}
      </b-col>
    </b-row>
    <table class="w-100 table-striped">
      <thead>
        <th>ENGINE NAME</th>
        <th>KICK OF GOH</th>
      </thead>
      <tbody v-if="loading">
        <tr>
          <td colspan="5" class="text-center">
            <b-spinner small></b-spinner>
            Loading...
          </td>
        </tr>
      </tbody>

      <tbody v-else-if="dataForm.runningHours && dataForm.runningHours.length">
        <template v-for="(item, i) in dataForm.runningHours">
          <tr :key="i">
            <td>
              <div>
                <strong>{{ item.powerType }}</strong>
                <br />
                <small v-if="item?.powerSeriesName">
                  {{ item.powerSeriesName }}
                </small>
                <small v-else>
                  {{ item.powerSeries?.name }} - {{ item.powerSeries?.model }}
                </small>
              </div>
            </td>
            <td style="width: 45%">
              <div>
                <InputCurrency
                  placeholder="0"
                  :disabled="!!selectedData"
                  class="mr-1 text-left bg-white"
                  v-model="item.hour"
                  prepend=""
                  append="Hours"
                />
              </div>
            </td>
          </tr>
        </template>
      </tbody>

      <tbody v-else>
        <tr>
          <td colspan="5" class="text-center">Not Found Running History</td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex mt-4" v-if="!selectedData">
      <b-button
        variant="outline-primary"
        class="w-50 mr-3"
        type="button"
        @click="$emit('close')"
      >
        Cancel
      </b-button>
      <b-button
        v-if="!loadingSubmit"
        variant="primary"
        type="submit"
        class="w-50"
      >
        Submit
      </b-button>
      <b-button
        variant="primary"
        v-else
        class="w-50 d-flex align-items-center justify-content-center"
        disabled
      >
        <b-spinner small class="mr-1"></b-spinner>
        Saving...
      </b-button>
    </div>
    <div v-else>
      <b-button
        variant="outline-primary"
        class="w-100 mt-3"
        type="button"
        @click="$emit('close')"
      >
        Close
      </b-button>
    </div>
  </form>
</template>

<script>
import UserOptionTemplate from '@/src/components/global/Partial/UserOptionTemplate.vue'
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
  usersActions,
} from '@/src/Utils/helper'
import UserTemplate from '@/src/components/global/Partial/UserTemplate.vue'
import moment from '@/node_modules/moment/moment'
import { numberFormat } from '@/src/plugins/helpers'
import InputCurrency from '@/src/components/global/InputCurrency.vue'

export default {
  name: 'FormAdjustmentRunningHours',
  components: { UserOptionTemplate, UserTemplate, InputCurrency },
  props: {
    selectedData: null,
  },
  data() {
    return {
      loading: false,
      loadingSubmit: false,
      fleetOptions: [],
      listUsers: [],
      userDetail: {
        name: '',
        photo: '',
      },
      dataForm: {
        employee_id: null,
        vehicleId: null,
        effectiveDate: '',
        remark: '',
        runningHours: [],
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...usersActions,
    ...maintenanceActions,
    ...pmsActions,
    disableAfterToday(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0) // biar hanya tanggal yang dihitung
      return date > today // disable jika lebih besar dari hari ini
    },
    async fetchFleets() {
      try {
        let params = {
          page: 1,
          perPage: 9999,
          showAll: true,
          active: true,
        }

        let res = await this.getFleets(params)

        if (res.status) {
          if (res.data && res.data.length > 0) {
            this.fleetOptions = res.data.map((val) => ({
              ...val,
              text: val.name,
              value: val.id,
            }))
            this.fleetFilteredOptions = this.fleetOptions
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    async fetchVehiclePowerList() {
      this.loading = true
      try {
        if (this.dataForm.vehicleId) {
          const res = await this.getVehiclePowerListV3(this.dataForm.vehicleId)
          const { data } = res?.data
          this.dataForm.runningHours = data.map((rh) => ({
            vehiclePowerId: rh.id,
            powerSeriesId: rh.power_series.id,
            powerSeries: rh.power_series,
            powerTypeId: rh.power_type.id,
            totalMinutes: rh.total_running_hour * 60,
            powerType: rh.power_type.name,
            min: null,
            hour: null,
          }))
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },

    async handleSubmit() {
      try {
        if (!this.dataForm.vehicleId || !this.dataForm.effectiveDate) {
          this.$swal(
            'Warning',
            'Vehicle or Effective Date Required.',
            'warning'
          )
          return false
        }
        this.loadingSubmit = true
        const body = {
          vehicle_id: this.dataForm?.vehicleId,
          kick_off: this.dataForm?.runningHours?.map((item) => ({
            vehicle_power_id: item?.vehiclePowerId,
            power_type_id: item?.powerTypeId,
            power_series_id: item?.powerSeriesId,
            kick_off_goh: Number(item?.hour),
            kick_off_goh_minutes: this.toMinutes(item?.hour, item?.min),
            remarks: this.dataForm.description,
            effective_date: moment(
              this.dataForm.effectiveDate,
              'DD-MM-YYYY'
            ).format('YYYY-MM-DD'),
          })),
        }

        const res = await this.createGOH(body)

        if (res.status == 'success') {
          this.$swal(
            'Success',
            res?.data?.message ?? 'Success Save Adjustment Kick Off Hours',
            'success'
          ).then((result) => {
            if (result.isConfirmed) {
              this.$emit('close')
            }
          })
          this.$emit('refetch')
        } else {
          this.$swal(
            'Error',
            res?.data?.message || 'Failed Save Adjustment Kick Off Hours',
            'error'
          )
        }
        this.loadingSubmit = false
      } catch (error) {
        console.log(error)
        this.$swal('Error', 'Failed System Error', 'error')
      } finally {
        this.loadingSubmit = false
      }
    },

    handleCheckAll(e) {
      const { checked } = e.target
      this.dataForm.forEach((item) => {
        item.checked = checked
      })
    },
    toMinutes(hour, minutes) {
      return Number(hour) * 60 + Number(minutes)
    },
    toHourMinute(totalMinutes) {
      // const duration = moment.duration(totalMinutes, 'minutes')
      // const hours = Math.floor(duration.asHours())
      // const minutes = duration.minutes()
      const hours = numberFormat(Math.floor(totalMinutes / 60))
      return `${hours} Hours`
    },
    formateDate(date) {
      return moment(date).format('DD MMM YYYY')
    },
  },
  watch: {
    selectedData: {
      handler(newVal) {
        if (newVal) {
          this.dataForm.runningHours =
            newVal?.powers?.map((power) => ({
              vehiclePowerId: power?.id,
              powerSeriesId: power?.power_series?.id,
              powerSeriesName: power?.power_series,
              powerTypeId: power?.power_type?.id,
              totalMinutes: power?.total_running_hour * 60,
              powerType: power?.power_type,
              hour: power?.kick_off_goh,
              min: null,
            })) || []
          this.dataForm.effectiveDate = newVal.powers[0]?.effective_date
          this.dataForm.description = newVal.powers[0]?.remarks
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchFleets()
  },
}
</script>
<style scoped>
table th {
  padding: 8px 12px;
}
table td {
  padding: 8px 12px;
  color: black;
}
.font-semibold {
  font-weight: 600;
}
</style>
